import { render, staticRenderFns } from "./zhiboclass.vue?vue&type=template&id=7a74bc78&scoped=true"
import script from "./zhiboclass.vue?vue&type=script&lang=js"
export * from "./zhiboclass.vue?vue&type=script&lang=js"
import style0 from "./zhiboclass.vue?vue&type=style&index=0&id=7a74bc78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74bc78",
  null
  
)

export default component.exports